module.exports = __webpack_public_path__ + "img/bg_login.bc1bc355.png";